export const ATRIUM_HALF = 35; // atrium spans ±35 in x and z
export const CORRIDOR_HALF_WIDTH = 5; // corridors are 10 m wide
export const UNIT_FACADE_WIDTH = 12;
export const UNIT_DEPTH = 25;
export const UNITS_PER_SIDE = 4;
export const FLOORS = 2;
export const FLOOR_HEIGHT = 7; // upper corridor floor sits at y=7
export const WING_MARGIN = 6; // corridor margin before first/after last unit
export const CORRIDOR_LENGTH = WING_MARGIN * 2 + UNITS_PER_SIDE * UNIT_FACADE_WIDTH; // 60
const WING_TITLES = {
    north: "North Promenade",
    east: "East Arcade",
    west: "West Galleria",
};
/** Preferred wing per store theme; overflow spills to the emptiest wing. */
const WING_PREFERENCE = {
    apparel: "north",
    home: "east",
    fun: "west",
    misc: "west",
};
const CAPACITY = UNITS_PER_SIDE * 2 * FLOORS;
export function computeMallLayout(shops) {
    const assignment = {
        north: [],
        east: [],
        west: [],
    };
    // Anchor tenants (acp-feed) get slot 0 of their preferred wing.
    const ordered = [...shops].sort((a, b) => {
        if (a.source !== b.source) {
            return a.source === "acp-feed" ? -1 : 1;
        }
        return a.name.localeCompare(b.name);
    });
    for (const shop of ordered) {
        const preferred = WING_PREFERENCE[shop.wing ?? "misc"] ?? "west";
        let target = preferred;
        if (assignment[target].length >= CAPACITY) {
            // Spill to the wing with the most free space.
            const byFree = Object.keys(assignment).sort((w1, w2) => assignment[w1].length - assignment[w2].length);
            target = byFree[0];
        }
        if (assignment[target].length >= CAPACITY) {
            // Mall is full; remaining stores are not placed this pass.
            console.warn(`[mallLayout] No slot left for ${shop.id}`);
            continue;
        }
        assignment[target].push(shop);
    }
    for (const wing of Object.keys(assignment)) {
        while (assignment[wing].length < CAPACITY) {
            assignment[wing].push(null);
        }
    }
    const wings = {
        north: assignment.north.map((s, i) => placeUnit("north", i, s)),
        east: assignment.east.map((s, i) => placeUnit("east", i, s)),
        west: assignment.west.map((s, i) => placeUnit("west", i, s)),
    };
    return { wings, wingTitles: WING_TITLES };
}
/**
 * Slot i walks the ground floor first (side A then side B), then the upper
 * floor, so anchor/popular stores land downstairs. Facade centers sit on the
 * corridor wall lines (±CORRIDOR_HALF_WIDTH), advancing outward from the
 * atrium.
 */
export function placeUnit(wing, indexInWing, shop) {
    const perFloor = UNITS_PER_SIDE * 2;
    const floor = Math.floor(indexInWing / perFloor);
    const onFloor = indexInWing % perFloor;
    const sideA = onFloor < UNITS_PER_SIDE;
    const k = sideA ? onFloor : onFloor - UNITS_PER_SIDE;
    const along = ATRIUM_HALF + WING_MARGIN + UNIT_FACADE_WIDTH / 2 + k * UNIT_FACADE_WIDTH;
    let x;
    let z;
    let rotationY;
    if (wing === "north") {
        // Corridor along +z. Side A = east wall (rooms extend +x), side B = west.
        x = sideA ? CORRIDOR_HALF_WIDTH : -CORRIDOR_HALF_WIDTH;
        z = along;
        rotationY = sideA ? Math.PI / 2 : -Math.PI / 2;
    }
    else if (wing === "east") {
        // Corridor along +x. Side A = north wall (rooms extend +z), side B = south.
        x = along;
        z = sideA ? CORRIDOR_HALF_WIDTH : -CORRIDOR_HALF_WIDTH;
        rotationY = sideA ? 0 : Math.PI;
    }
    else {
        // west: corridor along -x. Side A = north wall, side B = south.
        x = -along;
        z = sideA ? CORRIDOR_HALF_WIDTH : -CORRIDOR_HALF_WIDTH;
        rotationY = sideA ? 0 : Math.PI;
    }
    return { shop, wing, indexInWing, floor, x, y: floor * FLOOR_HEIGHT, z, rotationY };
}
//# sourceMappingURL=mallLayout.js.map